<template>
    <div class="animated fadeIn is-background-dark1">
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-white">
                            {{ $t('home:connect_everywhere.header') }}
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                    <div class="column content" style="flex: inherit">
                        <figure class="image img-600" v-if="!isMobile()">
                            <img alt="World coverage PTT" src="./assets/world-coverage.svg" width="600" height="600">
                        </figure>
                        <figure class="image featured-in-img-mobile mobile-screen" v-else>
                            <img alt="World coverage PTT" src="./assets/world-coverage.svg" width="300" height="300">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('home:connect_everywhere.description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-2x uptin-text-center">
                        <router-link :to="'poc-vs-radio'" class="uptin-text-center uptin-text-7 text-yellow" active-class="is-active is-active--advertiser">
                            {{ $t('poc:poc.poc_vs_radio') }}
                            <i v-bind:class = "isPersian(currentLocale)?'fas fa-angle-left text-yellow':'fas fa-angle-right text-yellow'"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
</style>

<script>
export default {
    components: {
    },
    name: 'connect-everywhere',
    data() {
        return {
            currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
        };
    },
    methods: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        isPersian(locale) {
            return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
        }
    }
}
</script>
